/**
 * 챌린지 채점이 **어디서 도는가** — 판정은 여기 한 곳(2026-10-05).
 *
 *  · 웹        서버가 정한 교육DB 계정에서 돈다. 학생에게 연결을 고르라고 하지 않는다.
 *              쿼리챌린지(001)는 시스템 풀(`systemPool`), 튜닝(003·004)은 서버의 채점 연결
 *              (백엔드 `modules/challenge/challengeDb.js`) — 둘 다 교육DB 의 edu 계정이다.
 *  · 스탠드얼론  서버 계정이 없다 — 사용자의 활성 연결.
 *
 * 화면 코드가 이 판정을 따로 하면 한쪽만 바뀐다(001 은 서버에서, 003 은 활성 연결에서 도는 식으로).
 */
import axios from 'axios';
import { IS_STANDALONE } from '../config/features';
import { getActiveConnectionId } from '../redux/actions/schemaActions';

const API = process.env.REACT_APP_API_BASE_URL || '/sql-developer';

/** 서버가 채점 DB 를 정하는가 — 웹이면 true */
export const SERVER_GRADED = !IS_STANDALONE;

/** 쿼리챌린지(001·002) 채점 SQL 을 실을 곳 — `/fetch-data` 본문에 펼쳐 넣는다. */
export function queryGradingTarget() {
  if (SERVER_GRADED) return { systemPool: true };
  const connectionId = getActiveConnectionId();
  return connectionId ? { connectionId } : { error: 'noConnection' };
}

/** 튜닝 채점(003·004)에 실을 연결 — 웹은 비운다(서버가 정하고, 보내도 보지 않는다). */
export function tuningGradingTarget() {
  if (SERVER_GRADED) return { server: true };
  const connectionId = getActiveConnectionId();
  return connectionId ? { connectionId } : { error: 'noConnection' };
}

/**
 * 채점 DB 에 붙는가 — 문제를 풀기 전에 확인한다(웹만).
 * @returns {Promise<{ serverManaged: boolean, ready?: boolean, systemPool?: boolean, reason?: string, name?: string }>}
 */
export async function fetchChallengeDbStatus() {
  if (!SERVER_GRADED) return { serverManaged: false };
  const res = await axios.get(`${API}/challenge/challenge-db`);
  return res.data || { serverManaged: true, ready: false };
}
